/* file description */
import SpQiankun from './sp-qiankun';

export type { SpQiankunPropsType } from './sp-qiankun';
export default SpQiankun;

